import React from "react";
import { Card, CardContent, CardMedia } from "@material-ui/core";
import { useStyles } from "./styles";

const ProductCard = ({ product, onClick }) => {
  const classes = useStyles({ imageBackground: product.imageBackground });
  const options = product.options || [product];

  const handleClick = (selectedProduct) => {
    if (onClick) {
      onClick(selectedProduct);
    }
  };

  return (
    <Card className={classes.card}>
      <div className={classes.imageContainer}>
        <CardMedia
          component="img"
          className={classes.image}
          image={product.thumbnailPath || "https://via.placeholder.com/280x180"}
          alt={product.title}
        />
      </div>
      <CardContent className={classes.content}>
        <div className={classes.title}>{product.title}</div>
        <div className={classes.description}>{product.description}</div>
        <div className={classes.options}>
          {options.map((option) => (
            <button
              key={option.id}
              type="button"
              className={classes.optionButton}
              onClick={() => handleClick(option)}
            >
              <span className={classes.optionPrice}>${option.price}</span>
              <span className={classes.optionPeriod}>/{option.billingLabel}</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
